import Cookies from 'js-cookie';

const PRESERVED_STORAGE_KEYS = [
  'cookieConsent',
  'appDownloadBanner',
  'preferredLanguage',
];

const preserveImportantDataOnLogout = () => {
  const preservedData: Record<string, string> = {};

  PRESERVED_STORAGE_KEYS.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value) {
      preservedData[key] = value;
    }
  });

  return preservedData;
};

const restorePreservedData = (preservedData: Record<string, string>) => {
  Object.entries(preservedData).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};

export const logoutFromUI = ({
  withoutReload = false,
}: { withoutReload?: boolean } = {}) => {
  const preservedData = preserveImportantDataOnLogout();

  localStorage.clear();

  restorePreservedData(preservedData);

  Cookies.remove('id');
  Cookies.remove('refreshToken');
  console.log('logoutFromUI: reloading page');

  if (!withoutReload) {
    window.location.reload();
  }
};
